/** sessionStorage key set when OTP + NextAuth sign-in complete (client-only). */
const LOGIN_COMPLETED_AT_KEY = "dido:loginCompletedAt";

/** Window after login where 401s are retried instead of forcing sign-out. */
export const LOGIN_GRACE_MS = 8_000;

export function markLoginCompleted(): void {
  if (typeof window === "undefined") return;
  sessionStorage.setItem(LOGIN_COMPLETED_AT_KEY, String(Date.now()));
}

export function isWithinLoginGracePeriod(): boolean {
  if (typeof window === "undefined") return false;
  const raw = sessionStorage.getItem(LOGIN_COMPLETED_AT_KEY);
  if (!raw) return false;
  const completedAt = Number.parseInt(raw, 10);
  if (!Number.isFinite(completedAt)) return false;
  return Date.now() - completedAt < LOGIN_GRACE_MS;
}

export function clearLoginGracePeriod(): void {
  if (typeof window === "undefined") return;
  sessionStorage.removeItem(LOGIN_COMPLETED_AT_KEY);
}
